import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  /* background: white; */
  text-align: center;
  font-family: "GT Super Text";
  padding: 40px 15px;

  .heads-up {
    background: #fff;
    padding: 25px 25px;
    border: 6px solid #f5f2e4;
    border-radius: 30px;
    margin-bottom: 20px;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15), 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
    p {
      text-align: left;
      margin-bottom: 10px;
      font-family: "Inter";
      font-size: 14px;
      line-height: 140%;
      font-weight: 500;
      color: #383838;
      a {
        color: #4808d1;
      }
    }
    .small {
      margin-bottom: 0px;
      font-size: 12px;
      color: #383838;
      opacity: 0.6;
    }
  }

  .login-container {
    width: 370px;
    background: #f5f2e4;
    border-radius: 35px;
    padding-top: 40px;
    padding-bottom: 40px;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15), 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
  }

  .wide {
    width: 440px;
  }

  h1 {
    font-size: 22px;
    font-family: "GT Super Text";
    margin: 0 auto 15px auto;
    text-align: center;
    font-weight: 400;
  }

  h2 {
    font-size: 16px;
    font-family: "GT Super Text";
    margin: 0 auto 15px auto;
    text-align: center;
    font-weight: normal;
  }

  p {
    color: #777;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 15px;

    a {
      text-decoration: underline;
      color: #777;
    }
  }

  .warn {
    color: red;
    margin-bottom: 15px;
  }

  small {
    display: block;
    color: #383838;
    font-family: "Inter";
    font-size: 10px;
    max-width: 300px;
    margin: 0 auto 25px auto;
    line-height: 13px;
    opacity: 0.6;

    a {
      color: #383838;
      text-decoration: underline;
    }
  }

  .error,
  .message {
    font-size: 15px;
    margin-top: 15px;
    margin-bottom: 15px;
    line-height: 19px;
  }

  .error {
    color: red;
  }

  .message {
    color: #2a2315;
  }

  .auth {
    font-weight: 500;
    background: white;
    font-family: "Inter";
    border: 2px solid #2a2315;
    border-radius: 7px;
    padding: 10px 4px;
    width: 300px;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 15px;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }

    img {
      width: 22px;
      height: 22px;
      vertical-align: middle;
      margin-right: 12px;
      position: relative;
      top: -2px;
    }
  }
  .no-margin {
    margin-bottom: 0px;
  }

  .or {
    font-size: 16px;
    font-family: "Inter";
    color: #888;
    margin: 10px auto;
  }

  input {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 7px;
    border: 2px solid #2a2315;
    padding: 10px 8px;
    width: 300px;
    font-size: 16px;
    font-family: "Inter";
    background: white;
    margin-bottom: 15px;

    &:focus {
      font-weight: 500;
      border: 2px solid #30ab66;
      outline: 2px solid #30ab66;
    }
  }

  .email-input-container {
    margin-bottom: 15px;

    input {
      margin-bottom: 0px;
    }

    &.has-error {
      input {
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
      }
    }

    .email-error {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      color: white;
      background: #f06063;
      font-family: "Inter";
      font-size: 14px;
      width: 300px;
      font-weight: 600;
      border-radius: 0px 0px 7px 7px;
      padding: 5px;
      margin: auto;
      line-height: 17px;
      a {
        color: white;
        font-weight: 800;
      }
    }
  }

  .email-button {
    font-weight: 500;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 7px;
    border: 0 solid #2a2315;
    padding: 10px 8px;
    width: 300px;
    font-size: 16px;
    font-family: "Inter";
    background: #30ab66;
    color: white;
    cursor: pointer;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  .heading-group {
    margin-top: 20px;
    margin-bottom: 30px;
  }
`;
